module.exports = __webpack_public_path__ + "static/media/message-delivered.18fbe4fe.svg";